<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2a"><a id="page_ix"></a><a id="frontmatter02"></a>Acknowledgments</h2>
<p class="linespace"> </p>
<p class="para"><em>Street Magic</em> is a labor of love, and the book would never have come into being without the assistance, support, and occasional arse-kicking from a great many people.</p>
<p class="indent-para">Rachel Vater, my amazing agent, deserves credit for taking that initial draft and making it into a Real Book. Rose Hilliard, my esteemed editor, gave Pete, Jack, and Black London a home and took them to a new level with her enthusiasm and deft editorial hand.</p>
<p class="indent-para">Richelle Mead, owner of a sofa on which a large portion of the first draft was written and fellow <em>Vampire Justice</em> superfan, ensured with her encouragement that I would write the hardest and simultaneously most fun novel of my career to date.</p>
<p class="indent-para">Stacia Kane read an early draft and got every single one of my punk rock references, thus proving that she has both excellent taste in music and a slightly twisted imagination. I couldn’t ask for a better crit partner and I’m thrilled this was the book that brought us together.</p>
<p class="indent-para">Cherie Priest and Kat Richardson gave me cover quotes and encouragement, and along with all of Team Seattle, gave me drinks, dinner, and dance-offs during the marathon revision process. Jim Butcher also gave me a lovely cover quote while trapped with me in a small car in Seattle traffic, and <a id="page_xi"></a>did so with grace and aplomb. Jim, I promise never to do that again.</p>
<p class="indent-para">Karen Mahoney showed me London and conspired to make me sound English.</p>
<p class="indent-para">Liz Bourke translated the Irish flawlessly and didn’t think it was strange that I was asking for exorcism spells and curse words.</p>
<p class="indent-para">Sara McDonald has seen every iteration of Pete and Jack since the beginning, and has been a tireless cheerleader.</p>
<p class="indent-para">Chris McGrath, for the gorgeous cover and Adam Auerbach for stellar design.</p>
<p class="indent-para">Mom and Hal, my number-one fans.</p>
<p class="indent-para">And finally, the bands who made the music that is the lifeblood of Black London: the Clash, the Sex Pistols, the Anti-Nowhere League, Nick Cave, Concrete Blonde, the Pogues, Generation X, the Supersuckers, and many more.</p>
<p class="indent-para">Rock on.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?0f712b01